import { motion } from "framer-motion";
import { MANIFESTO, IMAGES } from "../data/site";

export const Manifesto = () => {
  return (
    <section id="story" data-testid="manifesto-section" className="py-24 md:py-40">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-start">
          {/* Sticky image */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className="overflow-hidden"
            >
              <img
                src={IMAGES.manifesto}
                alt="Bright minimalist bedroom"
                className="w-full aspect-[4/5] object-cover"
              />
            </motion.div>
            <p className="overline mt-6">Our Manifesto</p>
          </div>

          {/* Chapters */}
          <div className="lg:col-span-7 lg:pl-12">
            <h2 className="font-heading font-light text-4xl md:text-6xl tracking-tight leading-[1.05] mb-16 md:mb-24">
              We don't sell mattresses.
              <br />
              <span className="italic text-accent">We manufacture rest.</span>
            </h2>

            <div className="space-y-16 md:space-y-24">
              {MANIFESTO.map((c, i) => (
                <motion.div
                  key={c.number}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className="grid grid-cols-12 gap-4 md:gap-8 border-t border-border pt-8"
                  data-testid={`manifesto-chapter-${c.number}`}
                >
                  <span className="col-span-3 md:col-span-2 font-heading font-light text-5xl md:text-7xl text-accent leading-none">
                    {c.number}
                  </span>
                  <div className="col-span-9 md:col-span-10">
                    <h3 className="font-heading text-2xl md:text-3xl mb-3">{c.title}</h3>
                    <p className="text-base md:text-lg leading-relaxed text-foreground/70 max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
